
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import carbonLogo from "../../assets/carbon-logo.png";
import AssistantQuestionInput from "../Assistant/AssistantQuestionInput";
import playBtn from "../../assets/play-btn.png";
import "../../styles/owl.carousel.min.css";
import { PAGES, ROUTES } from "../../utils/constants";
import { callTrackingApi } from "../../utils/helperCookie";
import ReachFooter from "../WayReach";
import "./LandingPage.css";
import CoverBox from "./inner-parts/CoverBox";
import ExperienceBox from "./inner-parts/ExperienceBox";
import ExpertsBox from "./inner-parts/ExpertsBox";
import Testimonialcover from "./inner-parts/Testimonialcover";
import TrialBox from "./inner-parts/TrialBox";
import TrustBox from "./inner-parts/TrustBox";
import { getEventDay } from "../../redux/notifications";
import HubspotModel from "./inner-parts/HubspotModel";
import HowItWorks from "./inner-parts/HowItWorks";
import MessagePopup from "./inner-parts/MessagePopup";
import { setActiveUser, setLoggedIn, setUserData, setPasswordStage } from "../../redux/users";
import { setAboutYouStage, setHubspotStage } from "../../redux/stages";


import { Auth } from "aws-amplify";
import { toast } from "react-toastify";

import $ from "jquery";
window.$ = $;

const LandingPage = () => {
  const progressBar = useSelector((state) => state?.users?.progress);
  const dbDirectProgressBar = useSelector((state) => state?.users?.dbDirectProgress);
  const ollamaFileProgressBar = useSelector((state) => state?.users?.ollamaFileProgress);

  const navigate = useNavigate();
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const [signUpClicked, setSignUpClicked] = useState(false);
  const eventDay = useSelector(
    (state) => state?.notifications?.eventDayForLandingPage
  );
  const activeUser = useSelector((state) => state?.users?.activeUser);
  const [openEarlyAccess, setOpenEarlyAccess] = useState(false);
  const [howItWorks, setHowItWorks] = useState(false);
  const [messagePopup, setMessagePopup] = useState(false);
  const [messagecontent, setMessageContent] = useState("");
  

  const registerRef = useRef();

  
  // Add and Remove Class on scroll
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      if (scrollY > 400) {
        setScrolled(true);
        document.body.classList.add('header-hide');
      } else {
        setScrolled(false);
        document.body.classList.remove('header-hide');
      }
    };

    window.addEventListener("scroll", handleScroll);
    
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
    }, []);


  // Click to scroll down
  const sectionRef = useRef(null);
  const handleScroll = () => {
    sectionRef.current?.scrollIntoView({ behavior: 'smooth' }, 1000);
    sectionRef.current?.classList.add('fadeInUp');
    document.body.classList.add('scrolle');
  };


  // Show Ctrl+Shift+X
  const [showAssistant, setShowVersion] = useState(false);  
  useEffect(() => {
      
    // const handleKeyDown = (event) => {
    //   // Toggle version display on Ctrl+Shift+X
    //   if (event.ctrlKey && event.shiftKey && event.key === 'X') {
    //     setShowVersion(!showAssistant);
    //   }
    // };

    // window.addEventListener('keydown', handleKeyDown);
    // return () => {
    //   window.removeEventListener('keydown', handleKeyDown);
    // };

  }, [showAssistant]);
  

  useEffect(() => {
    // Get the query parameters from the URL
    const queryParams = new URLSearchParams(window.location.search);

    console.log(queryParams);
    console.log("query parameter");
    // Check if the specific parameter exists (e.g., ?howitworks=true)
    if (queryParams.has("howitworks")) {
      openHowItWorks(); // Trigger the function
    }
    if (queryParams.has("info")) {

      const info = queryParams.get("info");  // Example: "Register"

      if (info) {

        // Fetch the corresponding .txt file
        fetch(`/${info}.txt`)
          .then((response) => {
            if (!response.ok) {
              throw new Error("File not found");
            }
            return response.text();
          })
          .then((data) => { 

              if (data.trim()) {  // Check if file is empty
                console.log("in data condition");
                setMessageContent(data);
                openMessagePopup(); // Trigger the function
              }
            }
          )
          .catch((error) => setMessageContent("Error loading file: " + error.message));
      }
    }
  }, []);

  useEffect(() => {
    setSignUpClicked(false);
    dispatch(getEventDay());
  }, []);

  useEffect(() => {
    callTrackingApi({
      email: "",
      pagetitle: PAGES.HOME_PAGE,
      pagelink: pathname,
    });
  }, []);

  useEffect(() => {
    setTimeout(() => {
      // const wow = new WOW.WOW();
      // wow.init();
      //Load More
      $(".load-btn").click(function () {
        $(".FAQ-box").toggleClass("load-more");
      });
    }, 500);
  }, []);


  const handleModalClose = () => {
    setOpenEarlyAccess(false);
  };
  const opneEarlyAccess = () => {
    setOpenEarlyAccess(true);
  };

  const closeHowItWorks = () => {
    setHowItWorks(false);
  };
  const openHowItWorks = () => {
    setHowItWorks(true);
  };


  const closeMessagePopup = () => {
    setMessagePopup(false);
  };
  const openMessagePopup = () => {
    setMessagePopup(true);
  };
  


  const handelClickOfEarlyAccess = () => {
    window.scrollTo(0, registerRef.current.offsetTop);
  };

  const goToSignup = () => {
    navigate(ROUTES.SIGNUP);
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    });
  };

  const earlyAccessBtn = () => {
    let ele = "";
    if (!activeUser) {
      // if (eventDay === "true") {
      //   ele = (
      //     <button
      //       className="btnlandingpage access-btn"
      //       onClick={handelClickOfEarlyAccess}
      //     >
      //       Early Access <span>LEAs only</span>
      //     </button>
      //   );
      // } else {
      ele = (
        <button
          className="btnlandingpage-signup access-btn-signup access-btn"
          onClick={goToSignup}
        >
          Sign Up
        </button>
      );
      // }
      return ele;
    }
    return ele;
  };

  
  const handleSignout = () => {
    if (progressBar > 0 && progressBar <= 100 || dbDirectProgressBar > 0 && dbDirectProgressBar <= 100 || ollamaFileProgressBar > 0 && ollamaFileProgressBar <= 100) {
      toast.error(
        "Download in progress. Logging out or leaving the page will disrupt the process.",
        {
          position: "top-right",
          autoClose: false
        }
      );
    } else {
      Auth.signOut().then(() => {
        dispatch(setActiveUser(false));
        dispatch(setAboutYouStage(null));
        dispatch(setHubspotStage(null));
        dispatch(setLoggedIn(false));
        navigate(ROUTES.LANDING_PAGE);
        dispatch(setUserData(null));

      });
    }
  };


  const goToLogin = () => {
    navigate(ROUTES.LOGIN);
    dispatch(setPasswordStage(0));
  };
  


  return (
    <>
      <div id="landingPageW">





        {/*Top Section start*/}
        <div className="top-section" ref={sectionRef}>
          {/*banner start*/}
          <div className="banner">
            <div className="container text-center">
              <div className="carbon-logo">
                <img src={carbonLogo} width="280" height="47" alt="CARBN.AI" />
                <sup>TM</sup>
              </div>
              <h1>
              Extract Intelligence from Every IP  Transaction
              </h1>
              <p>
              Now Supercharged with IPDR analytics
              </p>
              <p>
              Leveraging ClearTrail's two decades of handling 1000s of Gbps of IP traffic to craft the ultimate compact IP decoder.
              </p>
              <div>
                {earlyAccessBtn()}
                <button
                  type="button"
                  className="btnlandingpage work-btn"
                  onClick={openHowItWorks}
                >
                  How it works
                </button>
                
              </div>
            </div>
          </div>
          {/*banner end*/}

          {/*insight start*/}
          <div className="insight-box">
            <div className="container">
              <h2 >
                Critical Insights Hidden
                <br /> within IP Data
              </h2>
              <div className="insight-col-box">
              <div className="insight-col">
                  Cleartext is only the
                  <br /> tip of captured network data 
                </div>
                <div className="insight-col">
                  Covert communications over encrypted messaging applications
                </div>
                <div className="insight-col">
                  Thousands of unknown
                  <br /> communication channels
                </div>
                <div className="insight-col">
                Deep packet inspection tools
                  <br /> need high-tech expertise
                </div>
              </div>
            </div>
          </div>
          {/*insight end*/}

          {/*surface start*/}
          <div className="surface-box">
            <div className="container">
            <h2>Surface the Deep Truth</h2>
              <p>
              To solve high-tech crimes, analysts must understand a suspect's pattern-of-life over the internet - the specific set of behaviours and movements associated with a particular entity over a given period of time - to have a clear understanding of what activities were done and when.
              </p>
              <div>
                {earlyAccessBtn()}
                <button
                  type="button"
                  className="btnlandingpage work-btn"
                  onClick={openHowItWorks}
                >
                  How it works
                </button>
              </div>
            </div>
          </div>
          {/*surface end*/}
        </div>
        {/*Top Section end*/}
        {/* experience box start */}
        <div className="experience-box">
          <div className="container">
            <div className="carbon-logo text-center">
              <img src={carbonLogo} width="280" height="47" alt="CARBN.AI" /><sup>TM</sup>
            </div>

            <div className="experience-inner-box d-md-flex justify-content-between">
              {/* left start */}
              <div className="experience-left">
                Experience
                <br /> the Future of PCAP and IPDR Analysis
              </div>
              {/* left end */}

              {/* right start */}
              <div className="experience-right">
                <p>
                  CARBN.AI<sup>TM</sup> is a PCAP and IPDR analytics tool, that automates the processing of volumes of data to reveal actionable intelligence swiftly.
                </p>
                <p>
                Its deep packet inspection capabilities construct a 360-degree profile, exposing devices used, web browsing behaviours, communication channels accessed, and more - painting a vivid picture of a suspect's digital life.
                </p>
              </div>
              {/* right end */}
            </div>
          </div>
        </div>
        {/* experience box end */}

        {/* feature box start */}
        <div className="feature-box">
          <div className="container">
            <div className="feature-col-box d-md-flex justify-content-between text-center align-items-start">
              {/* col start */}
              <div className="feature-col" data-wow-delay="0.7s">
                <h4>Unravel Connections</h4>
                <p>
                Discover communication links between multiple suspects over encrypted IP channels
                </p>
              </div>
              {/* col end */}

              {/* col start */}
              <div className="feature-col">
                <h4>Uncover Pattern-of-Life</h4>
                <p>
                Organise, summarise and interpret activities over encrypted communication channels
                </p>
              </div>
              {/* col end */}

              {/* col start */}
              <div className="feature-col">
                <h4>Experience a User-Friendly Interface</h4>
                <p>Instant visual insights, no technical expertise</p>
              </div>
              {/* col end */}

              {/* col start */}
              <div className="feature-col">
                <h4>Supports Multiple Input Data Types</h4>
                <p>Analyse PCAP data and IPDR data on a single interface for unparalleled insights</p>
              </div>
              {/* col end */}
            </div>

            <div className="text-center">
              {earlyAccessBtn()}
              <button
                type="button"
                className="btnlandingpage work-btn"
                onClick={openHowItWorks}
              >
                How it works
              </button>
            </div>
          </div>
        </div>
        {/* feature box end */}
        {/* access box start */}
        {/* <div className="access-box" ref={registerRef}>
          <div className="container d-md-flex justify-content-between">
           
            <div className="access-left">
              <img src="" alt="" />
              <button
                type="button"
                className="access-play-btn"
                onClick={openHowItWorks}
              >
                <img src={playBtn} alt="Play Icon" />
                <span>How it works</span>
              </button>
            </div>
            

            {eventDay ? (
              <div className="access-right">
                <h3>Get Early Access</h3>
                <p>
                  Join us for an Special Event to unveil CARBN.AI<sup>TM</sup>.
                  Attend and receive complimentary 1-month access, enabling you
                  to upload and analyse up to 1 GB of PCAP files. Sign up now
                  for this unique opportunity.
                </p>
                <p>
                  Event Date: <strong> 13, Tuesday</strong> | Time:{" "}
                  <strong>4:15 PM GST</strong>
                </p>
                <p>
                  Where: <strong>JW Marriott Marquis, Dubai and Virtual</strong>
                </p>
                {!activeUser && (
                  <button
                    className="btnlandingpage access-btn"
                    onClick={opneEarlyAccess}
                  >
                    Register Now <span>LEAs only</span>
                  </button>
                )}
              </div>
            ) : (
              ""
            )}
          </div>
        </div> */}
        {/* access box end */}
        {/* trust box start */}
        <TrustBox></TrustBox>
        {/* trust box end */}
        {/* experts box start */}
        <ExpertsBox></ExpertsBox>
        {/* experts box end */}
        {/* Testimonialcover box end */}
        <Testimonialcover></Testimonialcover>
        {/* Testimonialcover box end */}
        {/* trial box start */}
        {/* <TrialBox></TrialBox> */}
        {/* trial box end */}
        {/* cover box start */}
        <CoverBox></CoverBox>
        {/* cover box end */}
        <ReachFooter></ReachFooter>
      </div>
      <HubspotModel
        openEarlyAccess={openEarlyAccess}
        handleModalClose={handleModalClose}
      ></HubspotModel>
      <HowItWorks
        howItWorks={howItWorks}
        closeHowItWorks={closeHowItWorks}
      ></HowItWorks>

    {messagecontent &&
      <MessagePopup
        messageBox={messagePopup}
        closeMessageBox={closeMessagePopup}
        messageContent={messagecontent}
      ></MessagePopup>
    }

    </>
  );
};

export default LandingPage;
